import { render, staticRenderFns } from "./loading-indicator.vue?vue&type=template&id=537ffe14"
import script from "./loading-indicator.vue?vue&type=script&lang=ts"
export * from "./loading-indicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports